import {
  AllHTMLAttributes,
  ChangeEvent,
  forwardRef,
  useEffect,
  useState,
} from "react";
import clsx from "clsx";
import styles from "./Checkbox.module.scss";

type Props = AllHTMLAttributes<HTMLInputElement> & {
  callback?: (checked: boolean) => void;
  variant?: "primary" | "secondary";
};

export const Checkbox = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    callback,
    className,
    variant = "primary",
    children,
    checked,
    onChange,
    ...rest
  } = props;

  const [isChecked, setIsChecked] = useState(checked || false);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
    onChange?.(event);
    if (callback) callback(event.target.checked)
  };

  useEffect(() => setIsChecked(checked || false), [checked]);

  return (
    <label
      className={clsx(
        styles.checkbox,
        {
          [styles.primary]: variant === "primary",
          [styles.secondary]: variant === "secondary",
        },
        className,
      )}
    >
      <input
        ref={ref}
        type="checkbox"
        {...rest}
        checked={isChecked}
        onChange={handleChange}
      />
      <span className={styles.checkmark} />
      {children}
    </label>
  );
});

Checkbox.displayName = "Checkbox";
